module.exports = __webpack_public_path__ + "static/media/Colette Curve Single Headboard - 120 cm_Beige.8171c835.png";